import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import './Input.scss';
import PropTypes from 'prop-types';
import eyeSVG from '../../assets/eye.svg';
import eyeNotSVG from '../../assets/eye-not.svg';
import errorSVG from '../../assets/input-error.svg';

export const Input = (props) => {
  const { showErrorMessage = false } = props;
  const [isPswVisible, setPswVisible] = useState(false);
  const inputType = useMemo(() => {
    if (props.type === 'password' && !isPswVisible) {
      return 'password';
    }

    return 'text';
  }, [props.type, isPswVisible]);

  return (
    <>
      <div className="input-container">
        <input
          className={classNames('input', {
            hasValue: props.value,
            'input--error': props.error,
          })}
          {...props}
          type={inputType}
          readOnly={props.isReadOnly}
        />
        {props.type === 'password' ? (
          <div className="input__psw-eye" onClick={(e) => setPswVisible((val) => !val)}>
            <img src={isPswVisible ? eyeNotSVG : eyeSVG} alt={isPswVisible ? 'Hide password' : 'Show password'} />
          </div>
        ) : null}
        {props.label && <label className="label">{props.label}</label>}
      </div>
      {props.infoMsg && <span className="input__info-msg">{props.infoMsg}</span>}
      {props.error && showErrorMessage && (
        <span className="error">
          <img src={errorSVG} alt="input error icon" />
          {props.error}
        </span>
      )}
      {props.button && <div className="input__action">{props.button}</div>}
    </>
  );
};

Input.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  showErrorMessage: PropTypes.bool,
  infoMsg: PropTypes.element,
  button: PropTypes.element,
  isReadOnly: PropTypes.bool,
};
